.common {
  align-items: center;
  border-radius: 4px;
  box-shadow: 0 1px 2px rgb(0 0 0 / 9%);
  display: flex;
  flex-shrink: 0;
  font-family: Inter, sans-serif;
  font-size: 13px;
  font-weight: 500;
  gap: 4px;
  justify-content: center;
  letter-spacing: 0;
  line-height: 20px;
  padding: 4.5px 14px;
}

/* Primary  */

.primary {
  background: var(--velos-brand-pink);
  color: #fefeff;
  composes: common;

  &:hover {
    background: var(--velos-brand-pink-dark);
  }

  &[data-disabled] {
    background: #ffceef;
  }
}

.primarySm {
  composes: primary;
  height: 27px;
}

.primaryMd {
  composes: primary;
  height: 32px;
}

/* Outline  */

.outline {
  background: #fefeff;
  border: 1px solid #ececed;
  color: #757575;
  composes: common;
  height: 32px;

  &:hover {
    background: #ececed;
    color: #757575;
  }

  &[data-disabled] {
    background: #ececed;
    color: #babababa;
  }
}

.outlineSm {
  composes: outline;
  height: 27px;
}

.outlineMd {
  composes: outline;
  height: 32px;
}

/* Subtle  */

.subtle {
  background: unset;
  border: unset;
  box-shadow: unset;
  color: #757575;
  composes: common;

  &:hover {
    background: #f6f6f6;
    color: #757575;
  }

  &[data-disabled] {
    background: #ececed;
    color: #babababa;
  }
}

.subtleSm {
  composes: subtle;
  height: 27px;
}

.subtleMd {
  composes: subtle;
  height: 32px;
}

.subtleIcon {
  composes: subtle;
  padding-bottom: unset;
  padding-left: 6px;
  padding-right: 6px;
  padding-top: unset;
}

/* Delete  */

.delete {
  background: #f34f52;
  color: #fefeff;
  composes: common;

  &:hover {
    background: #e84e4c;
  }

  &[data-disabled] {
    background: #f9cdce;
  }
}

.deleteSm {
  composes: delete;
  height: 27px;
}

.deleteMd {
  composes: delete;
  height: 32px;
}

/* Grey  */

.grey {
  background: #f5f5f5;
  border: unset;
  box-shadow: unset;
  color: black;
  composes: common;
  height: 32px;

  &:hover {
    background: #eaeaea;
    color: black;
  }

  &[data-disabled] {
    color: grey;
  }
}

.greySm {
  composes: grey;
  height: 27px;
}

.greyMd {
  composes: grey;
  height: 32px;
}

.icon {
  background: unset;
  composes: grey;
  padding-bottom: unset;
  padding-left: 6px;
  padding-right: 6px;
  padding-top: unset;
}
